module.exports = __webpack_public_path__ + "img/qrcode.57303ed5.svg";